import n from "./isWalletTopUpCheckoutItem.mjs";
import "@ancon/wildcat-types";
function v(t, p) {
  const { product: r, quantity: u, modifications: a, upsellGroupId: I, totalPriceInclTax: s } = t;
  if (n(t)) {
    let e = null;
    if (p) {
      const l = p;
      e = JSON.stringify({
        id: l.id,
        prepaidWalletNumber: l.prepaidWalletNumber
      });
    }
    return {
      productType: r.productType,
      variantType: r.variantType,
      price: { unitPrice: s.amount },
      metaData: e,
      quantity: u,
      modifications: []
    };
  }
  return {
    variantId: r.variantId,
    quantity: u,
    modifications: a.map((e) => ({
      modification: e.modification,
      ingredientId: e.ingredientId,
      quantity: e == null ? void 0 : e.quantity,
      freeAmount: e == null ? void 0 : e.freeAmount,
      addOnGroupId: (e == null ? void 0 : e.groupId) || void 0,
      replaceId: e.replaceId || void 0,
      description: e == null ? void 0 : e.description
    })),
    upsellGroupId: I
  };
}
export {
  v as default
};
